//  gsap.utils.toArray(".comparisonSection").forEach(section => {
// 	let tl = gsap.timeline({
// 			scrollTrigger: {
// 				trigger: section,
// 				start: "center center",
       
// 				end: () => "+=" + section.offsetWidth, 
// 				scrub: true,
// 				pin: true,
//         anticipatePin: 1
// 			},
// 			defaults: {ease: "none"}
// 		});
	
// 	tl.fromTo(section.querySelector(".afterImage"), { xPercent: 100, x: 0}, {xPercent: 0})
// 	  .fromTo(section.querySelector(".afterImage img"), {xPercent: -100, x: 0}, {xPercent: 0}, 0);
// });



$(document).ready(function() {
  
 
	// function logoSlider() {
	// 	$(".as-feat-section .main-logo-section").slick({
	// 		infinite: !0,
	// 		slidesToShow: 3,
	// 		slidesToScroll: 1,
	// 		arrows: !1,
	// 		autoplay: !0,
	// 		autoplaySpeed: 2e3,
	// 		dots: !1,
	// 		responsive: [{
	// 			breakpoint: 767,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		}]
	// 	})
	// }
	// $(window).resize(function() {
	// 	$(window).width() <= 991 && logoSlider()
	// }), $(window).width() <= 991 && logoSlider()
});


  $(document).on("click", 'input.cus-size_t', function () {
  if ($(this).is(":checked")) {
    var cusprice = $(this).data('vp');
    if(cusprice >= '$45'){
      $('.free-ship-label').show();
    } else {
       $('.free-ship-label').hide();
    }
    
  }
});

  $(document).ready(function(){

    function fxn() {
        $(".product-info__buy-buttons .cpb-panels-tabs-button").addClass("show_insider"), 
        setTimeout(function() {
            $(".product-info__buy-buttons .cpb-panels-tabs-button").removeClass("show_insider")
        }, 500)
}
setInterval(fxn, 5000)
  
});

 // $(document).ready(function(){
      // Retrieve and set the checked state on page load
      var checkedCheckbox = sessionStorage.getItem('checkedCheckbox');
      if (checkedCheckbox) {
        $(".shopify-section--featured-product .cus-color_v[value='" + checkedCheckbox + "']").attr("checked", "checked");
      }

      // Attach a click event handler to all checkboxes with class "cus-color_v"
      $(".shopify-section--featured-product .cus-color_v").on("click", function(){
        // Remove the "checked" attribute from all checkboxes
        $(".shopify-section--featured-product .cus-color_v").removeAttr("checked");

        // Add the "checked" attribute only to the clicked checkbox
        $(this).attr("checked", "checked");

        // Store the checked state in localStorage
        sessionStorage.setItem('checkedCheckbox', $(this).val());
      });

     // Function to update images on page load
function updateImagesOnLoad2() {
 
      var cusvimgurlacsload2 = $(".shopify-section--featured-product .cus-color_v:checked").data('value2');
    // Show or hide images based on the selected color variant
    $('.shopify-section--featured-product .product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img').each(function () {
        var cusvimgurlthumbload2 = $(this).data('value');
        if (cusvimgurlacsload2 == cusvimgurlthumbload2) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    // Additional code for main images (if needed)
    // ...
}
    // });
    
  // Function to update images on page load
function updateImagesOnLoad() {
    var cusvimgurlacsload = $('.variant-picker__option-values input.cus-color_v:checked').data('value2');
    
    // Show or hide images based on the selected color variant
    $('.product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img').each(function () {
        var cusvimgurlthumbload = $(this).data('value');
        if (cusvimgurlacsload == cusvimgurlthumbload) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    // Additional code for main images (if needed)
    // ...
}

$(document).ready(function () {
    // Retrieve the last selected value from sessionStorage
    var lastSelectedValue = sessionStorage.getItem('lastSelectedValue');

    // Show or hide images based on the last selected value
    if (lastSelectedValue) {
        updateImages(lastSelectedValue);
    }

    // Update images on page load
    updateImagesOnLoad();
    updateImagesOnLoad2();
    // Handle click event for color variants
    $(document).on("click", '.variant-picker__option-values input.cus-color_v', function () {
        var cusvimgurl = $(this).data('value2');
        // Save the selected value to sessionStorage
        sessionStorage.setItem('lastSelectedValue', cusvimgurl);
        // Show or hide images based on the selected value
        updateImages(cusvimgurl);
    });

    // Function to update images based on the selected value
     function updateImages(selectedValue) {
        $('.product-gallery__thumbnail-list.c-temp-product-gallery__thumbnail-list img').each(function () {
             // var cusvimgurlacs = $('.variant-picker__option-values input.cus-color_v').val();
            var cusvimgurlthumb = $(this).data('value');
          // alert(cusvimgurlthumb);
            if (selectedValue == cusvimgurlthumb) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        $('.product-gallery__media.c-temp-product-gallery__media img').each(function () {
            // var cusmainimgurl = $(this).data('main-img');
          var cusmainimgurl = $(this).data('value4');
            if (selectedValue == cusmainimgurl) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        $('.product-gallery__media.c-temp-product-gallery__media').each(function () {
            // var cusmainimgurl2 = $(this).data('main-img-div');
          var cusmainimgurl2 = $(this).data('value3');
            if (selectedValue == cusmainimgurl2) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
});



  // Wrap the code in the DOMContentLoaded event
    // document.addEventListener("DOMContentLoaded", function() {
    //     // Get all target images by class name
    //     var targetImages = document.getElementsByClassName("targetImage");

    //     // Get all source images by class name
    //     var sourceImages = document.getElementsByClassName("sourceImage");

    //     // Add click event listener to each source image
    //     for (var i = 0; i < sourceImages.length; i++) {
    //         sourceImages[i].addEventListener("click", function() {
    //             // Get the clicked image path
    //             var clickedImagePath = this.src;

    //             // Set the target image src attribute to the clicked image path
    //             for (var j = 0; j < targetImages.length; j++) {
    //                 targetImages[j].src = clickedImagePath;
    //             }
    //         });
    //     }
    // });
document.addEventListener("DOMContentLoaded", function() {
        var targetImages = document.getElementsByClassName("targetImage");
        var sourceImages = document.getElementsByClassName("sourceImage");

        // Check if a selected image is stored in localStorage
        var storedImagePath = sessionStorage.getItem("selectedImagePath");
        if (storedImagePath) {
            for (var j = 0; j < targetImages.length; j++) {
                targetImages[j].src = storedImagePath;
            }
        }

        for (var i = 0; i < sourceImages.length; i++) {
            sourceImages[i].addEventListener("click", function() {
                 var clickedImagePath = this.src;

                // Set the target image src attribute to the clicked image path
                for (var j = 0; j < targetImages.length; j++) {
                    targetImages[j].src = clickedImagePath;
                }

                // Store the selected image path in localStorage
                sessionStorage.setItem("selectedImagePath", clickedImagePath);
            });
        }

    });
   // Wrap the code in the DOMContentLoaded event
    // document.addEventListener("DOMContentLoaded", function() {
    //     // Get all target images by class name
    //     var targetImages = document.getElementsByClassName("targetImage");

    //     // Get all source images by class name
    //     var sourceImages = document.getElementsByClassName("sourceImage2");

    //     // Add click event listener to each source image
    //     for (var i = 0; i < sourceImages.length; i++) {
    //         sourceImages[i].addEventListener("click", function() {
    //             // Get the clicked image path from the data-src attribute
    //             var clickedImagePath = this.getAttribute("data-v-img2");

    //             // Set the target image src attribute to the clicked image path
    //             for (var j = 0; j < targetImages.length; j++) {
    //                 targetImages[j].src = clickedImagePath;
    //             }
    //         });
    //     }
    // });

document.addEventListener("DOMContentLoaded", function() {
        var targetImages = document.getElementsByClassName("targetImage");
        var sourceImages = document.getElementsByClassName("sourceImage2");

        // Check if a selected image is stored in localStorage
        var storedImagePath = sessionStorage.getItem("selectedImagePath");
        if (storedImagePath) {
            // Set the target image src attribute to the stored image path
            for (var j = 0; j < targetImages.length; j++) {
                targetImages[j].src = storedImagePath;
            }
        }

        // Add click event listener to each source image
        for (var i = 0; i < sourceImages.length; i++) {
            sourceImages[i].addEventListener("click", function() {
                var clickedImagePath = this.getAttribute("data-v-img2");

                // Set the target image src attribute to the clicked image path
                for (var j = 0; j < targetImages.length; j++) {
                    targetImages[j].src = clickedImagePath;

                    // Store the selected image path in localStorage
                    sessionStorage.setItem("selectedImagePath", clickedImagePath);
                }
            });
        }
 
    });

$("a[href^='#'].cus_click-scroll").click(function(e) {
	e.preventDefault();
	
	var position = $($(this).attr("href")).offset().top;

	$("body, html").animate({
		scrollTop: position
	} /* speed */ );
});



